import React from "react";
import Sidebar from "../components/Sidebar";

const UserLayout = ({ children }) => (
  <div className="App flex flex-row">
    <Sidebar />
    {children}
  </div>
);

export default UserLayout;
